import { useRef, useState } from 'react'
import { DEMOS } from './HowToDemos'
import { openAuth } from './TopBar'

const CARDS: { title: string; body: string }[] = [
  { title: 'A game of orders of magnitude.', body: 'Way Off asks you to guess real-world numbers — not exactly, just to the right scale. Every scale is ten times the last.' },
  { title: 'A question. The answer is a number.', body: 'It could be tiny. It could be enormous. Getting it bang on isn’t the goal.' },
  { title: 'Land in the right ballpark.', body: 'Ones, thousands, millions, billions… all the way to quintillions. Pick the right zone and the points flow. That’s the whole game.' },
  { title: 'Pick a magnitude.', body: 'Turn the dial or tap a band to select an order of magnitude. Every notch is ten times the last.' },
  { title: 'Then pick a digit.', body: 'One tap, 1 to 9. That’s your guess.' },
  { title: 'Lock it in.', body: 'See how close you were — the closer, the more points.' },
  { title: 'Sign in for the best experience.', body: 'Keep your streak, pick a name, save your stats — free.' },
]

/** 7-card swipeable how-to-play. Swipe or tap through; Skip closes. */
export function HowToPlay({ onClose }: { onClose: () => void }) {
  const [i, setI] = useState(0)
  const track = useRef<HTMLDivElement>(null)
  const go = (n: number) => {
    const k = Math.max(0, Math.min(CARDS.length - 1, n))
    setI(k)
    const el = track.current!
    el.scrollTo({ left: k * el.clientWidth, behavior: 'smooth' })
  }
  const onScroll = () => {
    const el = track.current!
    const k = Math.round(el.scrollLeft / el.clientWidth)
    if (k !== i) setI(k)
  }
  return (
    <div className="modal-veil" onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal howto" role="dialog" aria-modal="true" aria-label="How to play">
        <div className="howto-track" ref={track} onScroll={onScroll}>
          {CARDS.map((c, k) => (
            <div className="howto-card" key={k} onClick={() => { if (k < CARDS.length - 1) go(k + 1) }}>
              <h2>{c.title}</h2>
              <p className="muted">{c.body}</p>
              {(() => { const D = DEMOS[k]; return <D /> })()}
              {k === CARDS.length - 1 && (
                <button className="btn" style={{ marginTop: 14 }} onClick={(e) => { e.stopPropagation(); onClose(); openAuth() }}>Sign up / Login</button>
              )}
            </div>
          ))}
        </div>
        <div className="howto-dots" role="tablist">
          {CARDS.map((_, k) => <button key={k} className={k === i ? 'on' : ''} aria-label={`card ${k + 1}`} onClick={() => go(k)} />)}
        </div>
        <div className="howto-nav">
          <button className="btn ghost skip" onClick={onClose}>Skip</button>
          <div style={{ display: 'flex', gap: 8 }}>
            {i > 0 && <button className="btn ghost" onClick={() => go(i - 1)}>← Back</button>}
            {i < CARDS.length - 1
              ? <button className="btn" onClick={() => go(i + 1)}>Next →</button>
              : <button className="btn" onClick={onClose}>Let's play</button>}
          </div>
        </div>
      </div>
    </div>
  )
}
